import { render, staticRenderFns } from "./viewerRules.vue?vue&type=template&id=5477b74b&scoped=true&"
import script from "./viewerRules.vue?vue&type=script&lang=js&"
export * from "./viewerRules.vue?vue&type=script&lang=js&"
import style0 from "./viewerRules.vue?vue&type=style&index=0&id=5477b74b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477b74b",
  null
  
)

export default component.exports